import type { GetProToken } from "../../../hooks/useProToken";
import type { ProRenderPayload } from "../../../lib/pro-agent-types";
import { AudiencePreviewCard } from "./AudiencePreviewCard";
import { CampaignConfirmCard } from "./CampaignConfirmCard";
import { CampaignResultsCard } from "./CampaignResultsCard";
import { CampaignsListCard } from "./CampaignsListCard";
import { InvitesConfirmCard } from "./InvitesConfirmCard";
import { MessageConfirmCard } from "./MessageConfirmCard";
import { PeopleListCard } from "./PeopleListCard";
import { PersonCard } from "./PersonCard";

// Dispatches a dock item's render payload to its bespoke confirm card
// (plan 188 W2-M8, task 803). One switch, one place to add the next
// Tier-D draft type.
export function RenderCard({
  payload,
  getToken,
  onDismiss,
}: {
  payload: ProRenderPayload;
  getToken: GetProToken;
  onDismiss: () => void;
}) {
  switch (payload.type) {
    case "draft_message":
      return (
        <MessageConfirmCard draft={payload} getToken={getToken} onDiscard={onDismiss} />
      );
    case "draft_campaign":
      return <CampaignConfirmCard draft={payload} />;
    case "prepare_invites":
      return (
        <InvitesConfirmCard draft={payload} getToken={getToken} onDiscard={onDismiss} />
      );
    case "get_person":
      return <PersonCard card={payload} />;
    case "list_campaigns":
      return <CampaignsListCard card={payload} />;
    case "list_people":
      return <PeopleListCard card={payload} />;
    case "get_campaign_results":
      return <CampaignResultsCard card={payload} />;
    case "preview_campaign_audience":
      return <AudiencePreviewCard card={payload} />;
    default:
      return null;
  }
}
